import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Company\SearchCustomerInChiftAccountingController::__invoke
* @see app/Http/Controllers/Company/SearchCustomerInChiftAccountingController.php
* @route '/api/company/{company}/chift/search-customer'
*/
const SearchCustomerInChiftAccountingController = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: SearchCustomerInChiftAccountingController.url(args, options),
    method: 'get',
})

SearchCustomerInChiftAccountingController.definition = {
    methods: ["get","head"],
    url: '/api/company/{company}/chift/search-customer',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Company\SearchCustomerInChiftAccountingController::__invoke
* @see app/Http/Controllers/Company/SearchCustomerInChiftAccountingController.php
* @route '/api/company/{company}/chift/search-customer'
*/
SearchCustomerInChiftAccountingController.url = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return SearchCustomerInChiftAccountingController.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Company\SearchCustomerInChiftAccountingController::__invoke
* @see app/Http/Controllers/Company/SearchCustomerInChiftAccountingController.php
* @route '/api/company/{company}/chift/search-customer'
*/
SearchCustomerInChiftAccountingController.get = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: SearchCustomerInChiftAccountingController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Company\SearchCustomerInChiftAccountingController::__invoke
* @see app/Http/Controllers/Company/SearchCustomerInChiftAccountingController.php
* @route '/api/company/{company}/chift/search-customer'
*/
SearchCustomerInChiftAccountingController.head = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: SearchCustomerInChiftAccountingController.url(args, options),
    method: 'head',
})

export default SearchCustomerInChiftAccountingController